import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import type { IconGlyph } from '@ipfabric/ui-components/Icon/IconGlyph';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type Props = {
  title: string;
  icon: IconGlyph;
  type: 'info' | 'error';
  className?: string;
  children?: ReactNode;
};

export const NoCredentialsBox: FC<Props> = (props) => {
  return (
    <div
      className={twMerge(
        classNames(
          'flex flex-row items-center gap-4 border-0 border-y border-solid border-divider bg-shade-05 p-4 text-default',
        ),
        props.className,
      )}
    >
      <Icon
        size='base'
        iconStyle='solid'
        glyph={props.icon}
        className={
          props.type === 'error' ? 'text-status-error' : 'text-status-info'
        }
      />
      <div>
        <div className='text-base font-semibold'>{props.title}</div>
        <div className='text-sm text-plain'>{props.children}</div>
      </div>
    </div>
  );
};
